/**
* Testimonials Slider
*/

const Slider = ( $ ) => {

	$( '#slider-quotes' ).slick( {
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		speed: 1000,
		fade: true,
	} );
};


export default Slider;



